<template>
  <div
    class="otb-calendar-period-item"
    role="dialog"
    tabindex="0"
    :aria-selected="isChecked"
    :aria-label="option.text"
    :class="[checkedClass, periodItemBookingMode]"
    @click="input(option.value)"
    v-on:keyup.enter="input(option.value)"
  >
    <label
      class="otb-calendar-period-item__label wb-type-copy-strong"
      :class="requestModeClass"
      v-html="option.text"
    ></label>
    <div>
      <wb-radio-control>
        <label class="otb-calendar-period-item__input">
          <input
            tabindex="-1"
            type="radio"
            name="request-period"
            :value="option.value"
            :checked="isChecked"
          />
        </label>
      </wb-radio-control>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

import {
  CalendarPeriodOption,
  CalendarPeriodOptionValue,
} from '../../models/entities/calendar.model';

import useCalendarPeriodItem from '../../composables/calendar-period-item.composable';

export default defineComponent({
  name: 'otb-calendar-period-item',
  props: {
    requestMode: Boolean,
    option: Object as () => CalendarPeriodOption,
    value: Object as () => CalendarPeriodOptionValue,
  },
  setup(props, { emit }) {
    const CalendarPeriodItem = useCalendarPeriodItem(props, { emit });

    const requestModeClass = computed(() => {
      return props.requestMode ? 'is-a-request' : '';
    });

    const periodItemBookingMode = computed(() => {
      return !props.requestMode ? 'otb-calendar-period-item-booking' : '';
    });

    return {
      requestModeClass,
      periodItemBookingMode,
      ...CalendarPeriodItem,
    };
  },
});
</script>
<style src="./calendar-period-item.scss" lang="scss"></style>
